import { api } from '@/shared/api/client';

export interface UserCertificateCourse {
  title: string;
  description?: string | null;
  duration_secs?: number | null;
  duration_seconds?: number | null;
  price?: number | null;
}

export interface UserCertificate {
  id: string;
  course: UserCertificateCourse;
  orig_file?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export const getUsersMeCertificates = async () => {
  const { data } = await api.get<UserCertificate[]>('/users/me/certificates/');
  return data;
};
